import { Inbox, RotateCcw, FileSpreadsheet, Upload } from 'lucide-react'
import { Button } from '@/components/ui/Button'

interface GerencialEmptyStateProps {
  onLast90Days: () => void
  onClearFilters: () => void
  onImport: () => void
}

/**
 * Empty state shown when filters return zero rows. Three CTAs replace
 * the cold "no records" message — see UX spec §4.3.
 */
export function GerencialEmptyState({
  onLast90Days,
  onClearFilters,
  onImport,
}: GerencialEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center border-2 border-dashed border-brand-dark-lighter rounded-monumenta">
      <div className="p-4 rounded-full bg-brand-gray/10 mb-4">
        <Inbox className="text-brand-gray" size={48} />
      </div>
      <h3 className="text-xl font-semibold text-white mb-2 font-display">
        Nenhum registro neste recorte
      </h3>
      <p className="text-brand-gray mb-6 max-w-md font-body">
        Os filtros atuais não retornaram resultados.
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        <Button variant="primary" size="md" onClick={onLast90Days}>
          <RotateCcw className="w-4 h-4 mr-2" />
          Tentar últimos 90 dias
        </Button>
        <Button variant="secondary" size="md" onClick={onClearFilters}>
          <FileSpreadsheet className="w-4 h-4 mr-2" />
          Limpar filtros
        </Button>
        <Button variant="ghost" size="md" onClick={onImport}>
          <Upload className="w-4 h-4 mr-2" />
          Importar planilha
        </Button>
      </div>
    </div>
  )
}
